import React from "react";
import { Link } from "react-router-dom";

function NotFound() {
  return (
    <main className="page">
      <section className="panel">
        <h1>Page not found</h1>
        <p className="muted">This link does not exist on WillPlay.</p>
        <Link to="/" className="primary-btn">
          Back to home
        </Link>
      </section>
    </main>
  );
}

export default NotFound;
